export const currencylist = [
  'INR - ₹','EUR - €','USD - $','JPY - ¥','BGN - BGN','CZK - Kč','DKK - Dkr','GBP - £','HUF - Ft','PLN - zł','RON - RON',
  'SEK - Skr','CHF - CHF','ISK - Ikr','NOK - Nkr','HRK - kn','RUB - RUB','TRY - TL','AUD - AU$','BRL - R$','CAD - CA$','CNY - CN¥',
  'HKD - HK$','IDR - Rp','ILS - ₪','KRW - ₩','MXN - MX$','MYR - RM','NZD - NZ$','PHP - ₱','SGD - S$','THB - ฿','ZAR - R'
]